import { combineComponents } from '@equifinance/shared';
import { FC, PropsWithChildren, ReactElement } from 'react';
import { ApplicationsProvider } from '../applications';
import { ApplicationsUIProvider } from '../applications/ApplicationsUIProvider';
import { CasesProvider } from '../cases';
import { AssigneesProvider } from '../assignees';
import { CasesUIProvider } from '../casesUI/CasesUIProvider';
import { UnderwritersProvider } from '../underwriters';

function BaseProviders({ children }: PropsWithChildren): ReactElement {
  return <>{children}</>;
}

export const CombinedProvider: FC<PropsWithChildren> = combineComponents(
  BaseProviders,
  CasesProvider,
  AssigneesProvider,
  CasesUIProvider,
);

export const UnderwriterCombinedProvider: FC<PropsWithChildren> = combineComponents(
  BaseProviders,
  ApplicationsProvider,
  UnderwritersProvider,
  ApplicationsUIProvider,
);
